import styled from 'styled-components';

export const EllipsisTextContainer = styled.div`
  overflow: hidden;
  .ellipsis-text {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;

    & > * {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;

export const ItemsContainer = styled.div`
  & > *:not(:last-child) {
    border-bottom: 1px solid var(--allie-color-neutral-10);
  }
`;

export const IconMobileContainer = styled.div`
  color: var(--allie-color-neutral-50) !important;
  svg {
    width: 14px;
    height: 14px;
    stroke: var(--allie-color-neutral-50) !important;
    color: var(--allie-color-neutral-50) !important;

    path {
      stroke: var(--allie-color-neutral-50) !important;
    }
  }

  ion-icon {
    font-size: 14px;
    width: 14px;
    height: 14px;
    color: var(--allie-color-neutral-50) !important;
    stroke: var(--allie-color-neutral-50) !important;
  }
`;

export const StyledClockIconMobileContainer = styled.div`
  svg {
    path {
      stroke: none !important;
      fill: var(--allie-color-neutral-50) !important;
    }
  }
`;

export const StyledProductionOrderStatusChipMobileContainer = styled.div`
  ion-chip {
    margin: 0 !important;
  }
`;
